import theme from "../../theme";
// type: simple | custom
// render: locale


export const MODAL_CREATE_REPORT = {
  noAccountPermissions: {
    name: 'check_no_account_permissions',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'createData.account.noPermissions',
    field: null,
    render: 'locale',
    color: null,
    submitTxt: 'common.button.confirm',
    cancelTxt: null
  },
  confirmDownloadReport: {
    name: 'confirm_download_report',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'createData.modal.download.saveReport',
    field: 'reportName',
    render: 'locale',
    color: null,
    submitTxt: 'common.button.downloadReport',
    cancelTxt: null
  },
  processingDownloadReport: {
    name: 'processing_download_report',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'createData.modal.download.downloading',
    field: 'null',
    render: 'processing',
    color: null,
    submitTxt: null,
    cancelTxt: null
  },
  downloadReportNoData: {
    name: 'download_report_no_data',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'createData.modal.download.Failed',
    field: null,
    render: 'locale',
    color: null,
    submitTxt: 'common.button.confirm',
    cancelTxt: null
  },
  downloadReportTimeOut: {
    name: 'download_report_time_out',
    type: 'custom',
    title: null,
    subTitle: null,
    content: 'createData.modal.download.timeOut',
    field: null,
    render: 'locale',
    color: null,
    submitTxt: 'createData.modal.download.downloadAgain',
    cancelTxt: 'common.button.cancel'
  },
  checkImportCustomfields: {
    name: 'check_import_customfields',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'createData.modal.importCustomFields',
    field: null,
    render: 'locale',
    color: null,
    submitTxt: 'common.button.confirm',
    cancelTxt: null
  },
  checkNoCustomfields: {
    name: 'check_no_customfields',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'createData.modal.noCustomFields',
    field: null,
    render: 'locale',
    color: null,
    submitTxt: 'common.button.confirm',
    cancelTxt: null
  },
  checkImportCampaign: {
    name: 'check_import_campaign',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'createData.modal.importOnlineCampaign',
    field: null,
    render: 'locale',
    color: null,
    submitTxt: 'common.button.confirm',
    cancelTxt: null
  },
  checkNoCampaign: {
    name: 'check_no_campaign',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'createData.modal.noOnlineCampaign',
    field: null,
    render: 'locale',
    color: null,
    submitTxt: 'common.button.confirm',
    cancelTxt: null
  },
  checkNoRunningOrPausedCampaign: {
    name: 'check_no_running_or_paused_campaign',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'createData.modal.noRunningOrPausedCampaign',
    field: null,
    render: 'locale',
    color: null,
    submitTxt: 'common.button.confirm',
    cancelTxt: null
  },
  checkImportMarketingCampaign: {
    name: 'check_import_marketing_campaign',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'createData.modal.importMarketingCampaign',
    field: null,
    render: 'locale',
    color: null,
    submitTxt: 'common.button.confirm',
    cancelTxt: null
  },
  checkNoMarketingCampaign: {
    name: 'check_no_marketing_campaign',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'createData.modal.noMarketingCampaign',
    field: null,
    render: 'locale',
    color: null,
    submitTxt: 'common.button.confirm',
    cancelTxt: null
  },
  checkNoTarget: {
    name: 'check_no_target',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'createData.modal.noTarget',
    field: null,
    render: 'locale',
    color: null,
    submitTxt: 'common.button.confirm',
    cancelTxt: null
  }
}

export const MODAL_SEND_LIST = {
  deleteReport: {
    name: 'delete_report',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'sendList.renderTdContent.deleteReportModal',
    field: 'weeklyReportName',
    render: 'locale',
    color: { button: 'error' },
    submitTxt: 'common.button.delete',
    cancelTxt: 'common.button.cancel'
  },
  completeCopy: {
    name: 'complete_copy',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'sendList.copyReport.complete',
    field: 'weeklyReportName',
    render: 'locale',
    color: null,
    submitTxt: null,
    cancelTxt: null
  },
  failedCopy: {
    name: 'failed_copy',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'sendList.copyReport.Failed',
    field: null,
    render: 'locale',
    color: { text: theme.palette.error.main },
    submitTxt: null,
    cancelTxt: null
  },
  completeSend: {
    name: 'complete_send',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'sendList.detail.completeTestSend',
    field: null,
    render: 'locale',
    color: null,
    submitTxt: null,
    cancelTxt: null
  },
  completeSendAllEmails: {
    name: 'complete_send_all_emails',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'sendList.detail.sendAllEmail.complete',
    field: null,
    render: 'locale',
    color: null,
    submitTxt: null,
    cancelTxt: null
  },
  checkNoEmail: {
    name: 'check_no_email',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'sendList.detail.sendAllEmail.noEmail',
    field: null,
    render: 'locale',
    color: null,
    submitTxt: 'sendList.detail.sendAllEmail.button.setting',
    cancelTxt: 'common.button.cancel'
  },
  completeTransReports: {
    name: 'complete_transReports',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'sendList.transferReport.transferred',
    field: 'weeklyReportName',
    render: 'locale',
    color: null,
    submitTxt: null,
    cancelTxt: null
  },
  failedTransReports: {
    name: 'failed_transReports',
    type: 'simple',
    title: null,
    subTitle: null,
    content: 'sendList.transferReport.failedtransfer',
    field: null,
    render: 'locale',
    color: { text: theme.palette.error.main },
    submitTxt: null,
    cancelTxt: null
  },
}